import { render } from "./info-staff-check.vue?vue&type=template&id=03077d46&scoped=true&ts=true"
import script from "./info-staff-check.vue?vue&type=script&lang=ts"
export * from "./info-staff-check.vue?vue&type=script&lang=ts"

import "./info-staff-check.vue?vue&type=style&index=0&id=03077d46&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03077d46"]])

export default __exports__